module.exports = __webpack_public_path__ + "img/google-fonts.fed5015a.svg";